import {useEffect} from "react";
import {isProduction} from "../services/config";

const CLARITY_ID = "wi7n7b3asc";

export const useClarity = () => {
    useEffect(() => {
        if (!isProduction) return;
        if (!CLARITY_ID) return;

        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
            t = l.createElement(r);
            t.async = true;
            t.src = `https://www.clarity.ms/tag/${  i}`;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", CLARITY_ID);
    }, []);
};
